import makeService from './api';

export default makeService('profile_strategy_qualities');
